import {
  LOGOUT,
  LOGIN_USER,
  SET_AUTH_LOADING,
  SET_USER_DATA,
  UPDATE_ACCESS_TOKEN,
  SET_HYDRATION,
  SET_ASPIRATION_DETAILS,
} from "./action.types";

import { refreshTokenService } from "../../endpoints/auth.service";
import { getCandidateDetails } from "@endpoints/candidate.service";
import store from "..";

interface User {
  user: any;
  companyDetails?: any;
  token: string;
  refreshToken: string;
}

interface SetUserDataPayload {
  user?: any;
  experiences?: any;
  educations?: any;
  certificates?: any;
  isCandidateProfileCompleted?: boolean;
  linkedAccount?:any
}

export const logout = () => ({
  type: LOGOUT,
});

export const loginUser = (payload: User) => ({
  type: LOGIN_USER,
  payload,
});

export const fetchCandidateDetails = async () => {
  try {
    const { success, data } = await getCandidateDetails();
    if (success) {
      const { _id, ...rest } = data;
      store.dispatch(setUserData({ ...rest, candidateId: _id }));
    }
  } catch (error) {
    throw error?.message;
  }
};

// export const refreshToken = (token: string) => async (dispatch: any) => {
//   try {
//     const { data } = await refreshTokenService(token);
//     dispatch({
//       type: LOGIN_USER,
//       payload: {
//         user: data.user,
//         companyDetails: data?.companyDetails,
//         token: data.token,
//         refreshToken: data.refreshToken,
//         linkedAccount: data.linkedAccount,
//       },
//     });
//     return data;
//   } catch (err) {
//     console.error(err);
//     dispatch(logout());
//     return null;
//   }
// };

// ----------------------------
// UPDATE ACCESS TOKEN ONLY
// (does NOT overwrite full auth state)
// ----------------------------
export const updateAccessToken = (token: string) => ({
  type: UPDATE_ACCESS_TOKEN,
  payload: token,
});

// ----------------------------
// REFRESH TOKEN (safe version)
// ----------------------------
// export const refreshToken =
//   (refreshToken: string) => async (dispatch: any) => {
//     try {
//       const { data } = await refreshTokenService(refreshToken);

//       // 🔥 Only update the access token (no state overwrite)
//       dispatch(updateAccessToken(data.token));

//       return data;
//     } catch (err) {
//       console.error("❌ Refresh token failed", err);
//       dispatch(logout());
//       return null;
//     }
//   };
// In your auth.action.ts - UPDATE the refreshToken action
export const refreshToken = (refreshToken: string) => async (dispatch: any) => {
  try {
    console.log("🔄 auth.action: Refreshing token");

    const response = await refreshTokenService(refreshToken);
    console.log("✅ auth.action: Refresh response", response);

    if (response && response.token) {
      // Update Redux state
      dispatch({
        type: "REFRESH_TOKEN_SUCCESS",
        payload: {
          token: response.token,
          refreshToken: response.refreshToken,
          user: response.user,
        },
      });

      return response;
    } else {
      console.error("❌ auth.action: No token in response");
      throw new Error("Refresh failed - no token received");
    }
  } catch (error) {
    console.error("❌ auth.action: Refresh token failed", error);

    // Clear local storage on failure
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    dispatch({
      type: "REFRESH_TOKEN_FAILURE",
      payload: error.message,
    });

    throw error;
  }
};

export const setUserData = (payload: SetUserDataPayload) => {
  return {
    type: SET_USER_DATA,
    payload: payload,
  };
};

export const setAuthLoading = (status: boolean) => {
  return {
    type: SET_AUTH_LOADING,
    payload: status,
  };
};

export const setHydration = (status: boolean) => {
  return {
    type: SET_HYDRATION,
    payload: status,
  };
};

export const setAspirationDetails = (status: boolean) => {
  return {
    type: SET_ASPIRATION_DETAILS,
    payload: status,
  };
};
